<div *ngIf="show" class="fld-row ai-ctr pwx-4 mwb-4 mwt-4 spinner">
  <mat-spinner diameter="20"></mat-spinner>
  <div class="status mwx-4">{{ status }}</div>
</div>
